export default "__VITE_PUBLIC_ASSET__ed8c7ed6__"